import { useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { EIMIT } from '@/enums/pageEnum';
import NProgress from 'nprogress';
export const useMenuItem = ({ callBack }: { callBack: (params?: any) => void }) => {
  const location = useLocation();

  const menuItemOnClick = useCallback(
    (val: any) => {
      if (val && val.detail.key !== location.pathname) return;
      callBack({ isReset: true });
    },
    [location.pathname, callBack],
  );

  useEffect(() => {
    callBack();
    setTimeout(() => {
      NProgress.done();
    }, 600);
    document.addEventListener(EIMIT, menuItemOnClick);
    return () => {
      document.removeEventListener(EIMIT, menuItemOnClick);
    };
  }, []);

  return {};
};

export default useMenuItem;
